<template>
  <el-dialog
    title="选择菜单"
    :visible="visible"
    width="50%"
    @open="handleOpen"
    @close="handleClose"
    append-to-body
    destroy-on-close
  >
    <div style="height: 300px; overflow-y: scroll">
      <el-tree
        ref="tree"
        node-key="id"
        show-checkbox
        highlight-current
        :data="data"
        :props="defaultProp"
        default-expand-all
        @check="handleCheck"
      ></el-tree>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="handleConfirm"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { selectMenu } from "@/api/system/menu";
import { toTree } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    menus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: [],
      selectNode: null,
      defaultProp: {
        label: "name",
        children: "children",
      },
    };
  },
  methods: {
    getMenu() {
      selectMenu(true)
        .then((data) => {
          this.data = toTree(data, -1);
        })
        .then(() => {
          this.menus.forEach((item) => {
            this.$refs.tree.setChecked(item.id, true, false);
          });
        });
    },
    handleCheck(data, { checkedNodes, halfCheckedNodes }) {
      this.selectNode = [...checkedNodes, ...halfCheckedNodes];
    },
    handleConfirm() {
      this.$emit("confirm", this.selectNode);
      this.$emit("update:editForm", {});
      this.handleClose();
    },
    handleOpen() {
      this.getMenu();
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/system/role/add-edit/menu.vue